<script setup lang="ts">
import { computed } from 'vue';

import ConfirmDialog from '@/components/ConfirmDialog.vue';
import type { ConnectorState } from '@/services/mcpConnectors';

import { MCPConnectorConfig } from './mcpConnectorConfig';

const isConfirmDialogOpen = defineModel<boolean>('isConfirmDialogOpen');

const props = defineProps<{
    connector: ConnectorState | null;
}>();

const emit = defineEmits<{
    confirm: [];
}>();

const copy = computed(() => {
    const provider = props.connector?.provider;
    const config = provider ? MCPConnectorConfig[provider] : undefined;
    if (!config) {
        return { title: '', description: '', accessNote: undefined };
    }
    return {
        title: `Remove ${config.name} access?`,
        description: `Removing access disconnects ${config.name} tools from Playground.`,
        accessNote: config.accessNote
    };
});
</script>

<template>
    <ConfirmDialog
        v-model:is-confirm-dialog-open="isConfirmDialogOpen"
        :title="copy.title"
        :description="copy.description"
        confirm-button-text="Remove access"
        @confirm="emit('confirm')"
    >
        <p
            v-if="copy.accessNote"
            class="text-xs text-muted-foreground bg-primary10 border border-border p-3 rounded-md"
        >
            {{ copy.accessNote }}
        </p>
    </ConfirmDialog>
</template>
